import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import { Row, Col, Button, Card, CardHeader, CardBody, Collapse } from 'reactstrap'
import CustomModal from '../../common/CustomModal/CustomModal'
import 'react-vertical-timeline-component/style.min.css'
import { formatDateWithTimezone } from '../../utils/utcTime'
import {
  DIRECT_MAIL,
  EMAIL,
  INCOMING_CALL,
  MEETING,
  OUT_GOING_CALL,
  SHARED_NOTE,
  TEXT_MESSAGE,
} from '../../constants/activityTypes'

import { ReactComponent as PhoneCallIcon } from '../../assets/icons/phone-call.svg'
import { ReactComponent as IncomingCallIcon } from '../../assets/icons/incoming-call.svg'
import { ReactComponent as EmailIcon } from '../../assets/icons/email.svg'
import { ReactComponent as MeetingIcon } from '../../assets/icons/meeting.svg'
import { ReactComponent as TextMessageIcon } from '../../assets/icons/text_message.svg'
import { ReactComponent as SharedNoteIcon } from '../../assets/icons/shared_note.svg'
import Filters from './Filters'
import { getSharedNotes } from './Redux/clickToCallActions'
import Loader from './../Loader'
import './index.scss'
import AttachmentList from '../../common/ContactCommonComponents/ContactHistoryTabs/components/AttachmentList'

const TimeLine = ({ data, showFilters, divisions, contactId, getSharedNotes, loading }) => {
  const [modalSeeFullNotes, setModalSeeFullNotes] = useState({
    isOpen: false,
    notes: '',
  })
  const [openNotes, setOpenNotes] = useState({})

  const scrollableRef = useRef(null)

  const [filterValues, setFilterValues] = useState({
    allActivities: false,
    activities: true,
    myActivities: false,
    myTeamActivities: false,
    division: [],
    activityType: [],
  })

  const [selectValues, setSelectValues] = useState({
    divisionOptions: [],
    activityTypeOptions: [],
  })

  useEffect(() => {
    if (
      filterValues.division.length === 0 &&
      !filterValues.myActivities &&
      !filterValues.myTeamActivities &&
      !filterValues.allActivities
    ) {
      setFilterValues({ ...filterValues, activities: true })
    }
  }, [filterValues.myActivities, filterValues.myTeamActivities, filterValues.division, filterValues.activities])

  useEffect(() => {
    loadData()
    loadSelectValues()
  }, [])

  const toggleNotes = (id) => {
    setOpenNotes((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const loadData = () => {
    let filter = {
      activities: filterValues.activities,
      allActivities: filterValues.allActivities,
      myActivities: filterValues.myActivities,
      myTeamActivities: filterValues.myTeamActivities,
      division: filterValues.division.length > 0 && filterValues.division,
      activityType: filterValues.activityType.length > 0 && filterValues.activityType,
      contactId,
    }
    getSharedNotes(contactId, { filter })
  }

  const loadSelectValues = async () => {
    const divisionOptions = [],
      activityTypeOptions = []
    divisions.data &&
      divisions.data.forEach((division) =>
        divisionOptions.push({
          label: division.name,
          value: division.id,
        })
      )

    const responseActivityType = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: 8 } },
    })
    responseActivityType.data.data.forEach((activity) =>
      activityTypeOptions.push({
        label: activity.name,
        value: activity.id,
      })
    )

    activityTypeOptions.push({
      label: 'Shard Notes',
      value: -1,
    })

    setSelectValues({ divisionOptions, activityTypeOptions })
  }

  const onChangeSwitches = (e) => {
    const { name, value } = e.target
    setFilterValues({
      ...filterValues,
      allActivities: false,
      activities: false,
      myActivities: false,
      myTeamActivities: false,
      division: [],
      [name]: value,
    })
  }

  const onChangeSelect = (value, e) => {
    const { name } = e
    const newSelectedValue = []
    if (value) {
      value.forEach((value) => {
        newSelectedValue.push(value.value)
      })
      if (name === 'division') {
        setFilterValues({
          ...filterValues,
          allActivities: false,
          activities: false,
          myActivities: false,
          myTeamActivities: false,
          division: [],
          [name]: newSelectedValue,
        })
      } else setFilterValues({ ...filterValues, [name]: newSelectedValue })
    } else {
      setFilterValues({ ...filterValues, [name]: [] })
    }
  }

  const resetScrollPosition = () => {
    if (scrollableRef?.current) {
      scrollableRef.current.scrollTop = 0
    }
  }

  const onSearchClick = () => {
    loadData()
    resetScrollPosition()
  }

  const composeIconBackgroundColor = (activityType) => {
    switch (activityType) {
      case EMAIL:
      case DIRECT_MAIL:
        return '#ff7450'
      case MEETING:
        return '#4ca3dd'
      case INCOMING_CALL:
        return '#d640d3'
      case OUT_GOING_CALL:
        return '#522888'
      case TEXT_MESSAGE:
        return 'goldenrod'
      case SHARED_NOTE:
        return 'green'
      default:
        return 'grey'
    }
  }

  const onSeeFullNotesClick = (notes) => {
    setModalSeeFullNotes({
      isOpen: !modalSeeFullNotes.isOpen,
      notes: notes || '',
    })
  }

  return (
    <>
      <CustomModal isOpen={modalSeeFullNotes.isOpen} toggle={onSeeFullNotesClick} headerText={'Full Notes'}>
        <Row>
          <Col>
            <div
              dangerouslySetInnerHTML={{
                __html: modalSeeFullNotes.notes,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button size='sm' color='danger' onClick={onSeeFullNotesClick} className='float-right'>
              Close
            </Button>
          </Col>
        </Row>
      </CustomModal>
      {showFilters && (
        <Row>
          <Col>
            <Filters
              values={filterValues}
              onChangeSwitches={onChangeSwitches}
              selectValues={selectValues}
              onChangeSelect={onChangeSelect}
              onSearchClick={onSearchClick}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <Card>
            <CardHeader>Timeline</CardHeader>
            <CardBody innerRef={scrollableRef} className='vertical-timeline-custom' id='scrollableTimeline'>
              <Row>
                <Col>
                  {loading && <Loader />}
                  {data && data.length > 0 && !loading && (
                    <VerticalTimeline>
                      {data &&
                        data.map(function (item, index) {
                          let icon = null
                          let activityName = item.activityTypeData.name
                          if (item.activityTypeData.id === OUT_GOING_CALL) icon = <PhoneCallIcon />
                          else if (item.activityTypeData.id === TEXT_MESSAGE) icon = <TextMessageIcon />
                          else if (item.activityTypeData.id === EMAIL || item.activityTypeData.id === DIRECT_MAIL)
                            icon = <EmailIcon />
                          else if (item.activityTypeData.id === MEETING) icon = <MeetingIcon />
                          else if (item.activityTypeData.id === INCOMING_CALL) icon = <IncomingCallIcon />
                          else if (item.activityTypeData.id === SHARED_NOTE) icon = <SharedNoteIcon />
                          return (
                            <VerticalTimelineElement
                              key={`${item.id}-${index}`}
                              className='vertical-timeline-element--work'
                              contentArrowStyle={{
                                background: 'transparent',
                              }}
                              iconStyle={{
                                background: composeIconBackgroundColor(item.activityTypeData.id),
                                color: '#fff',
                                fill: '#fff',
                              }}
                              icon={icon}
                            >
                              <h3 className='timeline-subject'>
                                {/* <span className='timeline-subject__subject'>Subject: </span> */}
                                {data.subject}
                              </h3>
                              {/* <p className='timeline-follow-up'>
                                  <span>
                                    <i className='far fa-hand-point-right mr-1' />
                                    {activity?.followUp === 0 ? 'Initial' : `Follow Up: ${activity?.followUp}`}
                                  </span>
                                </p> */}

                              <p className='timeline-activity-type'>
                                {icon && <div>{icon}</div>}
                                {activityName}
                              </p>
                              <span>
                                <AttachmentList attachments={item.attachments} />
                              </span>
                              <p className='timeline-notes'>
                                {/* <span className='timeline-notes__headline'>Notes: </span> */}
                                {item.activityTypeData.id === TEXT_MESSAGE ? (
                                  <Card>
                                    <div
                                      className='px-2 d-flex justify-content-between align-items-center'
                                      onClick={() => toggleNotes(item.id)}
                                      aria-expanded={!!openNotes[item.id]}
                                    >
                                      <span>{openNotes[item.id] ? 'Hide message' : 'View message'}</span>

                                      <i
                                        className={`fa ${openNotes[item.id] ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                        aria-hidden='true'
                                      />
                                    </div>

                                    <Collapse isOpen={!!openNotes[item.id]}>
                                      <CardBody>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: item.note,
                                          }}
                                        />
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : (
                                  <div
                                    ref={(el) => {
                                      if (el) {
                                        if (el.offsetHeight > 75) {
                                          el.style.height = '75px'
                                          const div = document.createElement('div')
                                          div.classList.add('seeFullNotes')
                                          const button = document.createElement('button')
                                          button.classList.add('button-full-notes')
                                          button.onclick = function () {
                                            return onSeeFullNotesClick(item.note)
                                          }
                                          const textButton = document.createTextNode('See full notes')
                                          button.appendChild(textButton)
                                          div.appendChild(button)
                                          el.appendChild(div)
                                        }
                                      }
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: item.note,
                                    }}
                                    className='timeline-notes__notes'
                                  />
                                )}
                              </p>
                              <div
                                className={`date-name-info ${
                                  index % 2 === 0 ? 'date-name-info__left' : 'date-name-info__right'
                                }`}
                              >
                                <span className='date-name-info__name'>{item.createdByData.name}</span>
                                {item.performedOnBehalf && item.performedOnBehalf !== item.createdBy && (
                                  <span className='date-name-info__name'>
                                    On Behalf Of: {item.performedOnBehalfData?.name || 'unknown'}
                                  </span>
                                )}
                                <span className='date-name-info__date mb-1'>
                                  <i className='fa fa-calendar mr-1' aria-hidden='true'></i>
                                  {formatDateWithTimezone(item.creationDate, 'YYYY-MM-DD')}
                                </span>
                                <span className='date-name-info__date-time mb-1'>
                                  <i className='fa fa-clock-o' aria-hidden='true'></i>{' '}
                                  {formatDateWithTimezone(item.creationDate, 'hh:mm A')}
                                </span>
                                <span className='date-name-info__call'>
                                  {item?.callData?.duration ? (
                                    <>
                                      CALL DURATION: <span>{item.callData.duration} SECONDS</span>
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </span>
                              </div>
                            </VerticalTimelineElement>
                          )
                        })}
                    </VerticalTimeline>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  contacts: state.contacts.contacts,
  errors: state.errors,
  data: state.ClickToCall.timelineData,
  divisions: state.divisions.divisions,
  loading: state.ClickToCall.loading,
})

export default connect(mapStateToProps, { getSharedNotes })(TimeLine)
